import { mdmBrandCodeToRelationName } from "@/lib/cat/mdm-brand-names";
import type { KvpsBrandLetter } from "@/lib/kvps";
import { buildKvps } from "@/lib/kvps";
import type { MdmContact } from "@/types/cat/mdm-account.types";

export const MDM_EMAIL_BRAND_LABELS: Record<string, string> = {
  VW: "Volkswagen",
  VN: "Volkswagen Utilitaire",
  AU: "Audi",
  SD: "SKODA",
  ST: "SEAT",
};

const KVPS_TO_MDM_BRAND: Record<KvpsBrandLetter, string> = {
  V: "VW",
  N: "VN",
  A: "AU",
  C: "SD",
  S: "ST",
};

export function kvpsBrandLetterToMdmEmailBrand(
  letter: string | null | undefined,
): string | null {
  if (!letter) return null;
  const normalized = letter.trim().toUpperCase();
  if (normalized in KVPS_TO_MDM_BRAND) {
    return KVPS_TO_MDM_BRAND[normalized as KvpsBrandLetter];
  }
  return null;
}

export function resolveMdmEmailBrandFromKvpsIdentifier(
  kvpsIdentifier: string | null | undefined,
): string | null {
  if (!kvpsIdentifier?.trim()) return null;
  try {
    const kvps = buildKvps(kvpsIdentifier.trim(), "");
    return kvpsBrandLetterToMdmEmailBrand(kvps.parts.brand);
  } catch {
    const last = kvpsIdentifier.trim().slice(-1).toUpperCase();
    return kvpsBrandLetterToMdmEmailBrand(last);
  }
}

function isActiveContact(contact: MdmContact): boolean {
  const status = contact.status?.trim().toLowerCase();
  return !status || status === "actif";
}

export function pickActiveEmailForMdmBrand(
  contacts: MdmContact[] | undefined,
  mdmBrandCode: string | null,
): string {
  const emails = (contacts ?? []).filter(
    (c) => c.channel === "email" && isActiveContact(c),
  );
  if (emails.length === 0) return "";

  if (mdmBrandCode) {
    const brandNorm = mdmBrandCode.trim().toUpperCase();
    const brandAliases = new Set(
      [
        brandNorm,
        MDM_EMAIL_BRAND_LABELS[brandNorm],
        mdmBrandCodeToRelationName(brandNorm),
      ]
        .filter((value): value is string => Boolean(value?.trim()))
        .map((value) => value.trim().toUpperCase()),
    );
    const matched = emails.find((c) => {
      const contactBrand = c.brand?.trim().toUpperCase() ?? "";
      return brandAliases.has(contactBrand);
    });
    if (matched?.value?.trim()) return matched.value.trim();
    console.warn("[pickActiveEmailForMdmBrand] no email for brand", brandNorm);
  }

  return emails.find((c) => c.value?.trim())?.value?.trim() ?? "";
}
